/**
 * Wraps HTTP(S) URL link labels in `<span class="breaking-url">` inside autolinked `<a>` tags.
 * Applied after markdown → HTML conversion.
 */
export function wrapLongUrlsInHtml(html: string): string {
  return html.replace(
    /<a\b([^>]*)>([^<]*)<\/a>/gi,
    (full, attrs: string, text: string) => {
      const hrefMatch = attrs.match(/\bhref=(["'])(https?:\/\/.*?)\1/i);
      const href = hrefMatch?.[2];

      if (!href) {
        return full;
      }

      let updatedAttrs = attrs;
      if (/\bclass=(["']).*?\1/i.test(updatedAttrs)) {
        updatedAttrs = updatedAttrs.replace(
          /\bclass=(["'])(.*?)\1/i,
          (_, quote, classes) => {
            if (/\bbreaking-url\b/i.test(classes)) {
              return `class=${quote}${classes}${quote}`;
            }
            return `class=${quote}${classes} breaking-url${quote}`;
          },
        );
      } else {
        updatedAttrs = `${updatedAttrs} class="breaking-url"`;
      }

      return `<a${updatedAttrs}><span class="breaking-url">${text}</span></a>`;
    },
  );
}
